// extracted by mini-css-extract-plugin
export default {"provinceIt":"ProvinceItem_provinceIt__3FD3c"};